// internationalization
import { useTranslation } from 'react-i18next';

// shared components
import InsetDrawer from '@/components/ui/drawer/InsetDrawer';

// components
import type { PortfolioReMoniFactor } from '@/utils/remoniScoreCalculator';

// relative
import PortfolioHighlightDetailsContent from './PortfolioHighlightDetailsContent';

interface PortfolioHighlightDetailsDrawerProps {
  metric: PortfolioReMoniFactor | null;
  open: boolean;
  onClose: () => void;
  onOpenAnalysis: (metric: PortfolioReMoniFactor) => void;
}

const PortfolioHighlightDetailsDrawer = ({
  metric,
  open,
  onClose,
  onOpenAnalysis,
}: PortfolioHighlightDetailsDrawerProps) => {
  const { t } = useTranslation('energy-analysis');

  if (!metric) {
    return null;
  }

  return (
    <InsetDrawer
      open={open}
      onClose={onClose}
      width={960}
      title={t('portfolio.highlights.remoni_score')}
    >
      <PortfolioHighlightDetailsContent
        metric={metric}
        onOpenAnalysis={onOpenAnalysis}
      />
    </InsetDrawer>
  );
};

export default PortfolioHighlightDetailsDrawer;
